// NATIVE 

// INSTALLED 

// CUSTOM 
import { checkingPreload, unCheckingPreload } from '../loading';
import { setTipoNovedadesRedux, storeTipoNovedadRedux } from './TipoNovedadSlice';
import { activeTipoNovedadService, createTipoNovedadService, desactiveTipoNovedadService, 
     getAllTipoNovedadesByPaginateService, getAllTipoNovedadService, getTipoNovedadDetailService, updateTipoNovedadDetailService } from '../../services/tiponovedad.service';




export const getTipoNovedadStore = (): any => {

    return async( dispatch: any ) => {


      await dispatch( checkingPreload() );
      


      const result = await  getAllTipoNovedadService();

     
      dispatch( unCheckingPreload() );

      if ( result.ok ) {

          await dispatch( setTipoNovedadesRedux(result.data) );

      }
      
      return result;
        
    }
}






export const storeCreateTipoNovedad = (tipoNovedad: any, percentage:any): any => {


    return async( dispatch: any ) => { 

    
      const dataTipoNovedad = {
        name: tipoNovedad.name, 
        description: ( tipoNovedad.description ) ? tipoNovedad.description : '', 
        accion_1: ( tipoNovedad.accion_1.value ) ? tipoNovedad.accion_1.value: '', 
        resultado_1: ( tipoNovedad.resultado_1.value ) ? tipoNovedad.resultado_1.value: '', 
        cantidad_1: ( tipoNovedad.cantidad_1.value ) ? tipoNovedad.cantidad_1.value: '', 
        accion_2: ( tipoNovedad.accion_2.value ) ? tipoNovedad.accion_2.value: '', 
        resultado_2: ( tipoNovedad.resultado_2.value ) ? tipoNovedad.resultado_2.value: '', 
        cantidad_2: ( tipoNovedad.cantidad_2.value ) ? tipoNovedad.cantidad_2.value: '', 
        accion_3: ( tipoNovedad.accion_3.value ) ? tipoNovedad.accion_3.value: '', 
        resultado_3: ( tipoNovedad.resultado_3.value ) ? tipoNovedad.resultado_3.value: '', 
        cantidad_3: ( tipoNovedad.cantidad_3.value ) ? tipoNovedad.cantidad_3.value: '', 
        accion_4: ( tipoNovedad.accion_4.value ) ? tipoNovedad.accion_4.value: '', 
        resultado_4: ( tipoNovedad.resultado_4.value ) ? tipoNovedad.resultado_4.value: '', 
        cantidad_4: ( tipoNovedad.cantidad_4.value ) ? tipoNovedad.cantidad_4.value: '', 
      };


      const result = await  createTipoNovedadService(dataTipoNovedad, percentage);

     

      if ( result.ok ) {

        if ( Object.keys(result.data).length > 0  ) { 

          if (result.ok) {

              await dispatch( setTipoNovedadesRedux(result.data) );
          }

        }
        
      }
      
      
      return result;



    }



}




export const storeDesActiveTipoNovedad = (tipoNovedadId: string): any => {
    

  return async( dispatch: any ) => { 

      await dispatch( checkingPreload() );

      const result = await  desactiveTipoNovedadService(tipoNovedadId);

      
      dispatch( unCheckingPreload() );

      if ( result.ok ) {
                               
          await dispatch( setTipoNovedadesRedux(result.data) );

      }

      return result;

  }

    
}




export const storeActiveTipoNovedad = (tipoNovedadId: string): any => {
  

  return async( dispatch: any ) => { 

      await dispatch( checkingPreload() );
      

      const result = await  activeTipoNovedadService(tipoNovedadId);

      
      
      dispatch( unCheckingPreload() );

      if ( result.ok ) {
           
          await dispatch( setTipoNovedadesRedux(result.data) );

      }

      return result;

  }

    
}






export const getTipoNovedadByPagination = (page:number): any => {

    return async( dispatch: any ) => {


      await dispatch( checkingPreload() );


      const result = await  getAllTipoNovedadesByPaginateService(page);


      if ( result.ok ) {
          await dispatch( setTipoNovedadesRedux(result.data) );
      }
    
      dispatch( unCheckingPreload() );
      
      return result;
        
    }

}



export const storeDetailTipoNovedad = (tipoNovedadId: string): any => {
    

  return async( dispatch: any ) => { 


      await dispatch( checkingPreload() );


      const result = await  getTipoNovedadDetailService(tipoNovedadId);
    
      
      dispatch( unCheckingPreload() );

      if ( result.ok ) {           

            const dataTipoNovedad = {
              id:  result.data.id,
              name: result.data.name, 
              description: result.data.description,
              accion_1: result.data.accion_1, 
              resultado_1: result.data.resultado_1, 
              cantidad_1: result.data.cantidad_1, 
              accion_2: result.data.accion_2, 
              resultado_2: result.data.resultado_2, 
              cantidad_2: result.data.cantidad_2, 
              accion_3: result.data.accion_3, 
              resultado_3: result.data.resultado_3, 
              cantidad_3: result.data.cantidad_3, 
              accion_4: result.data.accion_4, 
              resultado_4: result.data.resultado_4, 
              cantidad_4: result.data.cantidad_4
            };
            
            await dispatch( storeTipoNovedadRedux(dataTipoNovedad) );
      }

     

      return result;

  }

    
}




export const storeEditTipoNovedad = (tipoNovedad: any): any => {
    

  return async( dispatch: any ) => { 


      await dispatch( checkingPreload() );
      
      
      

      const dataTipoNovedad = {
        tipoNovedadId: tipoNovedad.tipoNovedadId,
        name: tipoNovedad.e_name, 
        description: ( tipoNovedad.e_description ) ? tipoNovedad.e_description : '', 
        accion_1: ( tipoNovedad.e_accion_1.value ) ? tipoNovedad.e_accion_1.value: '', 
        resultado_1: ( tipoNovedad.e_resultado_1.value ) ? tipoNovedad.e_resultado_1.value: '', 
        cantidad_1: ( tipoNovedad.e_cantidad_1.value ) ? tipoNovedad.e_cantidad_1.value: '', 
        accion_2: ( tipoNovedad.e_accion_2.value ) ? tipoNovedad.e_accion_2.value: '', 
        resultado_2: ( tipoNovedad.e_resultado_2.value ) ? tipoNovedad.e_resultado_2.value: '', 
        cantidad_2: ( tipoNovedad.e_cantidad_2.value ) ? tipoNovedad.e_cantidad_2.value: '', 
        accion_3: ( tipoNovedad.e_accion_3.value ) ? tipoNovedad.e_accion_3.value: '', 
        resultado_3: ( tipoNovedad.e_resultado_3.value ) ? tipoNovedad.e_resultado_3.value: '', 
        cantidad_3: ( tipoNovedad.e_cantidad_3.value ) ? tipoNovedad.e_cantidad_3.value: '', 
        accion_4: ( tipoNovedad.e_accion_4.value ) ? tipoNovedad.e_accion_4.value: '', 
        resultado_4: ( tipoNovedad.e_resultado_4.value ) ? tipoNovedad.e_resultado_4.value: '', 
        cantidad_4: ( tipoNovedad.e_cantidad_4.value ) ? tipoNovedad.e_cantidad_4.value: '', 
      };

      

      const result = await  updateTipoNovedadDetailService(dataTipoNovedad);
    
      

      
      
      dispatch( unCheckingPreload() );
      
      if ( result.ok ) {

        await dispatch( setTipoNovedadesRedux(result.data) );

      }

      return result;

  }

    
}







